import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Service Worker DISABLED temporarily - may cause cookie/auth issues
// To re-enable PWA, uncomment the code below:
/*
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((registration) => {
        console.log('M\'art: ServiceWorker registered', registration.scope);
      })
      .catch((error) => {
        console.log('M\'art: ServiceWorker registration failed', error);
      });
  });
}
*/

// Unregister any existing service workers to fix cookie issues
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (let registration of registrations) {
      registration.unregister();
      console.log('M\'art: ServiceWorker unregistered to fix auth issues');
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
